import axios from 'axios';
import { getAuthToken, getAuthHeader } from './authService';

const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/companys/`;

export const addCompany = async (data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.post(`${API_URL}`, data, { headers });
        if (response.data) {

        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};

export const getCompanys = async (event_id: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    const params = {
        event_id: event_id
    };
    try {
        const response = await axios.get(`${API_URL}`, { headers, params });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};

export const getCompany = async (id: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}${id}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};

export const getCompanyOverview = async (id: string) => {
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}${id}/overview`, { headers });
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        return null;
    }
};

export type CompanyNoteAuthor = {
    id: number;
    username: string;
    email: string;
};

export type CompanyNote = {
    id: number;
    company_id: number;
    user_id: number;
    body: string;
    createdAt: string;
    updatedAt: string;
    author: CompanyNoteAuthor | null;
};

export type CompanyTimelineItem =
    | {
          type: "note";
          id: string;
          note_id: number;
          createdAt: string;
          author: CompanyNoteAuthor | null;
          body: string;
          can_edit: boolean;
          can_delete: boolean;
      }
    | {
          type: "magazine_booking";
          id: string;
          booking_id: number;
          createdAt: string;
          author: CompanyNoteAuthor | null;
          status: string;
          summary: string;
      };

export const createCompanyNote = async (companyId: string, body: string) => {
    const headers = getAuthHeader();
    const response = await axios.post(`${API_URL}${companyId}/notes`, { body }, { headers });
    return response.data as CompanyNote;
};

export const updateCompanyNote = async (companyId: string, noteId: number, body: string) => {
    const headers = getAuthHeader();
    const response = await axios.put(`${API_URL}${companyId}/notes/${noteId}`, { body }, { headers });
    return response.data as CompanyNote;
};

export const deleteCompanyNote = async (companyId: string, noteId: number) => {
    const headers = getAuthHeader();
    await axios.delete(`${API_URL}${companyId}/notes/${noteId}`, { headers });
};

export type ViesValidationLog = {
    id: number;
    company_id: number;
    user_id: number | null;
    vat_number: string;
    country_code: string;
    valid: boolean;
    registered_name: string | null;
    registered_address: string | null;
    request_identifier: string | null;
    error_message: string | null;
    createdAt: string;
    user: CompanyNoteAuthor | null;
};

export type CompanyVatFields = {
    vat_number?: string | null;
    vat_country_code?: string | null;
    vat_valid?: boolean | null;
    vat_validated_at?: string | null;
    vat_registered_name?: string | null;
    vat_registered_address?: string | null;
};

export const validateCompanyVat = async (companyId: string, vatNumber?: string) => {
    const headers = getAuthHeader();
    const response = await axios.post(
        `${API_URL}${companyId}/vat/validate`,
        vatNumber ? { vat_number: vatNumber } : {},
        { headers }
    );
    return response.data as {
        company: CompanyVatFields & { id: number; name: string };
        log: ViesValidationLog;
        vies_error: string | null;
    };
};

export const getCompanyVatLogs = async (companyId: string) => {
    const headers = getAuthHeader();
    const response = await axios.get(`${API_URL}${companyId}/vat/logs`, { headers });
    return response.data as ViesValidationLog[];
};

export const updateCompany = async (data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.put(`${API_URL}${data.id}`, data, { headers });
        if (response.data) {
            console.log('updated data', response.data);
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};
export const deleteCompany = async (id: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.delete(`${API_URL}${id}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};

